export default __webpack_public_path__ + "static/media/undraw_laravel_and_vue_59tp.7cf7a39a.svg";